import { PrismicError } from "./errors/PrismicError.js";
import { isRepositoryName } from "./isRepositoryName.js";
const getToolbarSrc = (repositoryName) => {
  if (isRepositoryName(repositoryName)) {
    return `https://static.cdn.prismic.io/prismic.js?new=true&repo=${repositoryName}`;
  } else {
    throw new PrismicError(`An invalid Prismic repository name was given: ${repositoryName}`, void 0, void 0);
  }
};
export {
  getToolbarSrc
};
//# sourceMappingURL=getToolbarSrc.js.map
